module.exports = __webpack_public_path__ + "img/sts.8b421e6a.png";